export default __webpack_public_path__ + "static/media/0xaecebfcf604ad245eaf0d5bd68459c3a7a6399c2.90a1cb98.webp";